/**
 * Clears select options from the specified index onwards.
 * @param select {HTMLSelectElement} HTML select element to clear options for
 * @param start {number} Index to start deleting options from (default is 0)
 */
export const clearSelectOptions = (select: HTMLSelectElement, start = 0) => {
  select.options.length = start;
};